/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  AddFavoriteItemRequest,
  BulkRemoveFavoriteItemsRequest,
  BulkRemoveFavoriteItemsResponse,
  CreateFavoriteListRequest,
  FavoriteItemDto,
  FavoriteListDto,
  FindMeFavoriteListV1Params,
  RenameFavoriteListRequest
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMeFavoritesV1Response200 = {
  data: FavoriteListDto[]
  status: 200
}

export type getMeFavoritesV1Response401 = {
  data: void
  status: 401
}

export type getMeFavoritesV1ResponseSuccess = (getMeFavoritesV1Response200) & {
  headers: Headers;
};
export type getMeFavoritesV1ResponseError = (getMeFavoritesV1Response401) & {
  headers: Headers;
};

export type getMeFavoritesV1Response = (getMeFavoritesV1ResponseSuccess | getMeFavoritesV1ResponseError)

export const getGetMeFavoritesV1Url = () => {




  return `/api/v1/me/favorites`
}

/**
 * Returns all favorite lists for the authenticated user.
 * @summary Get current user's favorite lists
 */
export const getMeFavoritesV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeFavoritesV1Response> => {

  return customFetch<getMeFavoritesV1Response>(getGetMeFavoritesV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type createMeFavoriteListV1Response201 = {
  data: FavoriteListDto
  status: 201
}

export type createMeFavoriteListV1Response400 = {
  data: void
  status: 400
}

export type createMeFavoriteListV1Response401 = {
  data: void
  status: 401
}

export type createMeFavoriteListV1ResponseSuccess = (createMeFavoriteListV1Response201) & {
  headers: Headers;
};
export type createMeFavoriteListV1ResponseError = (createMeFavoriteListV1Response400 | createMeFavoriteListV1Response401) & {
  headers: Headers;
};

export type createMeFavoriteListV1Response = (createMeFavoriteListV1ResponseSuccess | createMeFavoriteListV1ResponseError)

export const getCreateMeFavoriteListV1Url = () => {




  return `/api/v1/me/favorites`
}

/**
 * @summary Create a new favorite list
 */
export const createMeFavoriteListV1 = async (createFavoriteListRequest: CreateFavoriteListRequest, options?: Parameters<typeof customFetch>[1]): Promise<createMeFavoriteListV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createMeFavoriteListV1Response>(getCreateMeFavoriteListV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createFavoriteListRequest)
  }
);}


export type renameMeFavoriteListV1Response200 = {
  data: FavoriteListDto
  status: 200
}

export type renameMeFavoriteListV1Response400 = {
  data: void
  status: 400
}

export type renameMeFavoriteListV1Response401 = {
  data: void
  status: 401
}

export type renameMeFavoriteListV1ResponseSuccess = (renameMeFavoriteListV1Response200) & {
  headers: Headers;
};
export type renameMeFavoriteListV1ResponseError = (renameMeFavoriteListV1Response400 | renameMeFavoriteListV1Response401) & {
  headers: Headers;
};

export type renameMeFavoriteListV1Response = (renameMeFavoriteListV1ResponseSuccess | renameMeFavoriteListV1ResponseError)

export const getRenameMeFavoriteListV1Url = (listGuid: string,) => {




  return `/api/v1/me/favorites/${listGuid}`
}

/**
 * @summary Rename a favorite list
 */
export const renameMeFavoriteListV1 = async (listGuid: string,
    renameFavoriteListRequest: RenameFavoriteListRequest, options?: Parameters<typeof customFetch>[1]): Promise<renameMeFavoriteListV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<renameMeFavoriteListV1Response>(getRenameMeFavoriteListV1Url(listGuid),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(renameFavoriteListRequest)
  }
);}


export type deleteMeFavoriteListV1Response204 = {
  data: void
  status: 204
}

export type deleteMeFavoriteListV1Response400 = {
  data: void
  status: 400
}

export type deleteMeFavoriteListV1Response401 = {
  data: void
  status: 401
}

export type deleteMeFavoriteListV1ResponseSuccess = (deleteMeFavoriteListV1Response204) & {
  headers: Headers;
};
export type deleteMeFavoriteListV1ResponseError = (deleteMeFavoriteListV1Response400 | deleteMeFavoriteListV1Response401) & {
  headers: Headers;
};

export type deleteMeFavoriteListV1Response = (deleteMeFavoriteListV1ResponseSuccess | deleteMeFavoriteListV1ResponseError)

export const getDeleteMeFavoriteListV1Url = (listGuid: string,) => {




  return `/api/v1/me/favorites/${listGuid}`
}

/**
 * Deletes a favorite list and all its items. Cannot delete the default list.
 * @summary Delete a favorite list
 */
export const deleteMeFavoriteListV1 = async (listGuid: string, options?: Parameters<typeof customFetch>[1]): Promise<deleteMeFavoriteListV1Response> => {

  return customFetch<deleteMeFavoriteListV1Response>(getDeleteMeFavoriteListV1Url(listGuid),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type getMeFavoriteItemsV1Response200 = {
  data: FavoriteItemDto[]
  status: 200
}

export type getMeFavoriteItemsV1Response400 = {
  data: void
  status: 400
}

export type getMeFavoriteItemsV1Response401 = {
  data: void
  status: 401
}

export type getMeFavoriteItemsV1ResponseSuccess = (getMeFavoriteItemsV1Response200) & {
  headers: Headers;
};
export type getMeFavoriteItemsV1ResponseError = (getMeFavoriteItemsV1Response400 | getMeFavoriteItemsV1Response401) & {
  headers: Headers;
};

export type getMeFavoriteItemsV1Response = (getMeFavoriteItemsV1ResponseSuccess | getMeFavoriteItemsV1ResponseError)

export const getGetMeFavoriteItemsV1Url = (listGuid: string,) => {




  return `/api/v1/me/favorites/${listGuid}/items`
}

/**
 * @summary Get items in a favorite list
 */
export const getMeFavoriteItemsV1 = async (listGuid: string, options?: Parameters<typeof customFetch>[1]): Promise<getMeFavoriteItemsV1Response> => {

  return customFetch<getMeFavoriteItemsV1Response>(getGetMeFavoriteItemsV1Url(listGuid),
  {
    ...options,
    method: 'GET'


  }
);}


export type addMeFavoriteItemV1Response200 = {
  data: FavoriteItemDto
  status: 200
}

export type addMeFavoriteItemV1Response400 = {
  data: void
  status: 400
}

export type addMeFavoriteItemV1Response401 = {
  data: void
  status: 401
}

export type addMeFavoriteItemV1ResponseSuccess = (addMeFavoriteItemV1Response200) & {
  headers: Headers;
};
export type addMeFavoriteItemV1ResponseError = (addMeFavoriteItemV1Response400 | addMeFavoriteItemV1Response401) & {
  headers: Headers;
};

export type addMeFavoriteItemV1Response = (addMeFavoriteItemV1ResponseSuccess | addMeFavoriteItemV1ResponseError)

export const getAddMeFavoriteItemV1Url = (listGuid: string,) => {




  return `/api/v1/me/favorites/${listGuid}/items`
}

/**
 * Adds an item to the list. Idempotent — returns existing if already present.
 * @summary Add an item to a favorite list
 */
export const addMeFavoriteItemV1 = async (listGuid: string,
    addFavoriteItemRequest: AddFavoriteItemRequest, options?: Parameters<typeof customFetch>[1]): Promise<addMeFavoriteItemV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<addMeFavoriteItemV1Response>(getAddMeFavoriteItemV1Url(listGuid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addFavoriteItemRequest)
  }
);}


export type removeMeFavoriteItemV1Response204 = {
  data: void
  status: 204
}

export type removeMeFavoriteItemV1Response400 = {
  data: void
  status: 400
}

export type removeMeFavoriteItemV1Response401 = {
  data: void
  status: 401
}

export type removeMeFavoriteItemV1ResponseSuccess = (removeMeFavoriteItemV1Response204) & {
  headers: Headers;
};
export type removeMeFavoriteItemV1ResponseError = (removeMeFavoriteItemV1Response400 | removeMeFavoriteItemV1Response401) & {
  headers: Headers;
};

export type removeMeFavoriteItemV1Response = (removeMeFavoriteItemV1ResponseSuccess | removeMeFavoriteItemV1ResponseError)

export const getRemoveMeFavoriteItemV1Url = (listGuid: string,
    itemGuid: string,) => {




  return `/api/v1/me/favorites/${listGuid}/items/${itemGuid}`
}

/**
 * @summary Remove an item from a favorite list
 */
export const removeMeFavoriteItemV1 = async (listGuid: string,
    itemGuid: string, options?: Parameters<typeof customFetch>[1]): Promise<removeMeFavoriteItemV1Response> => {

  return customFetch<removeMeFavoriteItemV1Response>(getRemoveMeFavoriteItemV1Url(listGuid,itemGuid),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type bulkRemoveMeFavoriteItemsV1Response200 = {
  data: BulkRemoveFavoriteItemsResponse
  status: 200
}

export type bulkRemoveMeFavoriteItemsV1Response400 = {
  data: void
  status: 400
}

export type bulkRemoveMeFavoriteItemsV1Response401 = {
  data: void
  status: 401
}

export type bulkRemoveMeFavoriteItemsV1ResponseSuccess = (bulkRemoveMeFavoriteItemsV1Response200) & {
  headers: Headers;
};
export type bulkRemoveMeFavoriteItemsV1ResponseError = (bulkRemoveMeFavoriteItemsV1Response400 | bulkRemoveMeFavoriteItemsV1Response401) & {
  headers: Headers;
};

export type bulkRemoveMeFavoriteItemsV1Response = (bulkRemoveMeFavoriteItemsV1ResponseSuccess | bulkRemoveMeFavoriteItemsV1ResponseError)

export const getBulkRemoveMeFavoriteItemsV1Url = (listGuid: string,) => {




  return `/api/v1/me/favorites/${listGuid}/items/bulk-delete`
}

/**
 * REMOVE ALL UNAVAILABLE ITEMS: removes up to 200 items of the list in one call. Ids not in the list, or already removed, are ignored. Returns how many were removed. The list itself stays.
 * @summary Remove several items from a favorite list
 */
export const bulkRemoveMeFavoriteItemsV1 = async (listGuid: string,
    bulkRemoveFavoriteItemsRequest: BulkRemoveFavoriteItemsRequest, options?: Parameters<typeof customFetch>[1]): Promise<bulkRemoveMeFavoriteItemsV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<bulkRemoveMeFavoriteItemsV1Response>(getBulkRemoveMeFavoriteItemsV1Url(listGuid),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkRemoveFavoriteItemsRequest)
  }
);}


export type findMeFavoriteListV1Response200 = {
  data: FavoriteListDto
  status: 200
}

export type findMeFavoriteListV1Response400 = {
  data: void
  status: 400
}

export type findMeFavoriteListV1Response401 = {
  data: void
  status: 401
}

export type findMeFavoriteListV1ResponseSuccess = (findMeFavoriteListV1Response200) & {
  headers: Headers;
};
export type findMeFavoriteListV1ResponseError = (findMeFavoriteListV1Response400 | findMeFavoriteListV1Response401) & {
  headers: Headers;
};

export type findMeFavoriteListV1Response = (findMeFavoriteListV1ResponseSuccess | findMeFavoriteListV1ResponseError)

export const getFindMeFavoriteListV1Url = (params: FindMeFavoriteListV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/me/favorites/lookup?${stringifiedParams}` : `/api/v1/me/favorites/lookup`
}

/**
 * Returns the favorite list that already contains an item of the given type and external id, or null if none does.
 * @summary Find the favorite list containing an item
 */
export const findMeFavoriteListV1 = async (params: FindMeFavoriteListV1Params, options?: Parameters<typeof customFetch>[1]): Promise<findMeFavoriteListV1Response> => {

  return customFetch<findMeFavoriteListV1Response>(getFindMeFavoriteListV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


